/*! @azure/msal-browser v4.26.0 2025-10-29 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.26.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
